<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <i v-if="page_type == 'bookmark'" class="bi bi-chevron-left"
                            onclick="window.location.href = '/home'"></i>
                        <i v-else-if="page_type == 'good'" class="bi bi-chevron-left"
                            onclick="window.location.href = '/home'"></i>
                        <i v-else class="bi bi-chevron-left" onclick="window.location.href = '/setting'"></i>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5 v-if="page_type == 'bookmark'">お気に入り</h5>
                        <h5 v-else-if="page_type == 'good'">いいね</h5>
                        <h5 v-else-if="page_type == 'skip'">スキップ</h5>
                        <h5 v-else-if="page_type == 'block'">ブロック</h5>
                        <h5 v-else-if="page_type == 'penalty'">通報</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container" style="margin-top:56px;">
                <br>
                <div class="row">
                    <div class="col text-center">
                        <div v-if="page_type == 'bookmark'">あなたがお気に入りに追加した人一覧</div>
                        <div v-else-if="page_type == 'good'">あなたがいいねをした人一覧</div>
                        <div v-else-if="page_type == 'skip'">あなたがスキップをした人一覧</div>
                        <div v-else-if="page_type == 'block'">あなたがブロックをした人一覧</div>
                        <div v-else-if="page_type == 'penalty'">あなたが通報をした人一覧</div>
                    </div>
                </div>
                <br>
                <br>
                <div class="" v-for="user in user_list" :key="user.id"
                    :data-testid="`setting-list-item-${page_type == 'good' ? user.user_id_to : user.id}`"
                    style="padding: 10px 20px">
                    <div v-if="page_type == 'good'">
                        <div class="row" style="padding: 0px">
                            <div class="col-3 d-flex align-items-center"
                                :onclick="`window.location.href = '/user/show/${user.user_id_to}?profile_source=${profileSource}'`">
                                <img :src="user.icon_url" class="rounded-circle" style="width: 100%" />
                            </div>
                            <div class="col d-flex align-items-center"
                                :onclick="`window.location.href = '/user/show/${user.user_id_to}?profile_source=${profileSource}'`">
                                <div>
                                    <div>{{ user.name }}</div>
                                    <!-- comment はいいね送信時のみ設定されるため、matching_status を問わず有無だけで判定している -->
                                    <div v-if="user.matching_status == 4" class="good-badge good-badge-premium">プレミアムメッセージ付き</div>
                                    <div v-else-if="user.comment" class="good-badge good-badge-message">メッセージ付き</div>
                                    <div class="good-sent-at">送信日時：{{ formatGoodSentAt(user.created_at) }}</div>
                                </div>
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-end" style="color: #979c9e">
                                <div>
                                    <div v-if="user.matching_status == 0">スキップ</div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="padding: 0px" v-if="user.comment">
                            <div class="col-12">
                                <div class="good-message-bubble">{{ displayedComment(user) }}</div>
                                <div v-if="hasOverflow(user.comment)" class="good-message-toggle">
                                    <a v-if="!isExpanded(user.user_id_to)" class="show-more" @click="expandComment(user.user_id_to)">
                                        <i class="bi bi-chevron-down"></i>
                                        <span>もっと見る</span>
                                    </a>
                                    <a v-else class="show-more" @click="collapseComment(user.user_id_to)">
                                        <i class="bi bi-chevron-up"></i>
                                        <span>閉じる</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding: 0px" v-else>
                        <div class="col-3 d-flex align-items-center"
                            :onclick="`window.location.href = '/user/show/${user.id}?profile_source=${profileSource}'`">
                            <img :src="user.icon_url" class="rounded-circle" style="width: 100%" />
                        </div>
                        <div class="col d-flex align-items-center"
                            :onclick="`window.location.href = '/user/show/${user.id}?profile_source=${profileSource}'`">
                            {{ user.name }}
                        </div>
                        <div class="col-3 d-flex align-items-center justify-content-end" style="color: #979c9e">
                            <div @click="setPenalty(page_type, 0, user.id)" v-if="page_type != 'skip'">
                                解除
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
                <div class="text-center" style="padding-top: 100px; padding-bottom: 20px; color: #6c7072"
                    v-if="is_page && count != 0">
                    <a @click="fetchUsersMore">もっとみる</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            count: 0,
            is_load_under: false,
            is_load: true,
            is_page: false,
            page_status: "4",
            page_type: "",
            page: 1,
            requestId: 0,
            scrollY: 0,
            user_list: [],
            expandedComments: {},
        };
    },
    computed: {
        profileSource() {
            return {
                bookmark: 'bookmark_list', good: 'sent_likes', skip: 'skip_list',
                block: 'block_list', penalty: 'report_list',
            }[this.page_type] || 'unknown'
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
        window.addEventListener("pageshow", this.handlePageShow)
    },
    methods: {
        async fetchUsers() {
            const requestId = ++this.requestId

            if (this.page_type == "good") {
                this.page_status = "1"
            }

            await axios.get("/api/setting/" + this.page_type + "/list")
                .then((response) => {
                    if (requestId !== this.requestId) {
                        return
                    }

                    this.user_list = response.data.user_list.data
                    this.count = response.data.user_count
                    this.is_page = this.count > 20

                })
                .catch((error) => {
                    if (requestId !== this.requestId) {
                        return
                    }

                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    }
                }).finally(() => {
                    if (requestId === this.requestId) {
                        this.is_load = false
                    }
                })
        },
        handlePageShow(event) {
            if (!event.persisted) {
                return
            }

            this.page = 1
            this.count = 0
            this.is_page = false
            this.is_load = true
            this.is_load_under = false
            this.user_list = []
            this.expandedComments = {}
            this.fetchUsers()
        },
        async fetchUsersMore() {
            const requestId = this.requestId

            this.is_load_under = true
            this.page++

            await axios.get("/api/setting/" + this.page_type + "/list?page=" + this.page)
                .then((response) => {
                    if (requestId !== this.requestId) {
                        return
                    }

                    this.user_list.push.apply(this.user_list, response.data.user_list.data)

                    if (response.data.user_list.data.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (requestId !== this.requestId) {
                        return
                    }

                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    }
                }).finally(() => {
                    if (requestId === this.requestId) {
                        this.is_load_under = false
                    }
                })
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)
            if (p < 1 && this.is_page) {
                const requestId = this.requestId

                this.is_load_under = true
                this.page++

                await axios.get("/api/setting/" + this.page_type + "/list?page=" + this.page)
                    .then((response) => {
                        if (requestId !== this.requestId) {
                            return
                        }

                        this.user_list.push.apply(this.user_list, response.data.user_list.data)

                        if (response.data.user_list.data.length == 0) {
                            this.is_page = false
                        }
                    })
                    .catch((error) => {
                        if (requestId !== this.requestId) {
                            return
                        }

                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("設定の取得に失敗しました");
                        }
                    }).finally(() => {
                        if (requestId === this.requestId) {
                            this.is_load_under = false
                        }
                    })
            }
        },
        hasOverflow(text) {
            return !!text && text.length > 50
        },
        isExpanded(userId) {
            return !!this.expandedComments[userId]
        },
        expandComment(userId) {
            this.$set(this.expandedComments, userId, true)
        },
        collapseComment(userId) {
            this.$set(this.expandedComments, userId, false)
        },
        displayedComment(user) {
            if (!user.comment) {
                return ''
            }

            if (this.isExpanded(user.user_id_to) || user.comment.length <= 50) {
                return user.comment
            }

            return user.comment.slice(0, 50) + "…"
        },
        formatGoodSentAt(value) {
            if (!value) {
                return '-'
            }

            const date = new Date(value)
            if (Number.isNaN(date.getTime())) {
                return '-'
            }

            return new Intl.DateTimeFormat('ja-JP', {
                timeZone: 'Asia/Tokyo',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hourCycle: 'h23',
            }).format(date)
        },
        async setPenalty(p, t, u) {

            if (p == "bookmark") {
                let response = await axios
                    .post("/api/matching/bookmark/set", {
                        user_id_to: u,
                        type: t,
                    })
                    .then((response) => {
                        this.$router.go({ path: this.$router.currentRoute.path, force: true })
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("お気に入り登録に失敗しました");
                        }
                    })
            }
            else {
                let response = await axios.get("/api/matching/penalty/" + p + "/" + u + "/" + t + "/0")
                    .then((response) => {
                        this.$router.go({ path: this.$router.currentRoute.path, force: true })
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("通報に失敗しました");
                        }
                    })
            }
        },
    },
    async created() {
        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            localStorage.setItem('prev_page', this.$route.path)
                            localStorage.setItem('prev_type', 1)

                            this.page_type = this.$route.params['page']
                            this.fetchUsers()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    })
            }
            else {
                localStorage.setItem('prev_page', this.$route.path)
                localStorage.setItem('prev_type', 1)

                this.page_type = this.$route.params['page']
                this.fetchUsers()
            }
        }
        else {
            localStorage.setItem('prev_page', this.$route.path)
            localStorage.setItem('prev_type', 1)

            this.page_type = this.$route.params['page']
            this.fetchUsers()
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll)
        window.removeEventListener("pageshow", this.handlePageShow)
    },
    filters: {
        priceLocaleString(value) {
            return value.toLocaleString()
        },
    },
};
</script>
<style>
#tab_detail_1 {
    animation: fadein 1.5s forwards
}

.good-badge {
    display: inline-block;
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 8px;
    margin: 2px 0;
}

.good-badge-message {
    background-color: #eef3ff;
    color: #4a6cf7;
}

.good-badge-premium {
    background-color: #fff3e0;
    color: #d38b1d;
}

.good-sent-at {
    color: #979c9e;
    font-size: 12px;
    margin-top: 2px;
}

.good-message-bubble {
    font-size: 13px;
    color: #555;
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 6px 10px;
    margin-top: 2px;
    max-width: 100%;
    word-break: break-word;
}

.good-message-toggle {
    text-align: center;
    margin-top: 4px;
}

.good-message-toggle .show-more {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #ff2aa3;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
}

.good-message-toggle .show-more:hover,
.good-message-toggle .show-more:focus {
    text-decoration: none;
}
</style>
